export const styles = {
  columnsFilterContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  columnsFilter: {
    margin: '10px 15px',
    display: 'flex',
  },
  columnbutton: {
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 8px',
    marginRight: '6px',
    cursor: 'pointer',
  },
  columnOnButton: {
    backgroundColor: '#798498',
    color: 'white',
  },
  columnOffButton: {
    backgroundColor: '#EBEBEB',
    color: '#798498',
  },
  checkIcon: {
    marginLeft: '4px',
  },
  nonColumnsMessage: {
    margin: '0px 15px',
  },
}
